/**
 * views-public.js
 * ---------------
 * front-end javascript for VIEWS
 * by Philip Kuperberg
 */

// import "core-js/stable";
// import "regenerator-runtime/runtime";

import { setupRoutingEvents } from './src/routing';
import { setupCountdownEvents } from './src/countdowns';
import { setupModalEvents } from './src/modals';
import { setupSliders } from './src/sliders';
import { scrollTo, setupScrollEvents, contentOffset } from './src/scrolling';
import "./agenda-filters";

// import { setupMenuEvents } from '%/menus';
// import { setupAgendaEvents } from '%/agendas';
// import { setupGlobalEvents } from '%/global';
// import { setupGAEvents } from '%/ga-events';
// import { moduleRouter } from './src/module-router';

// import "../scss/style-patch.scss";


const $ = jQuery.noConflict();

let htmlClasses = document.documentElement.className;
if (htmlClasses.indexOf('evtx-page') >= 0){

   window.scrollTop = 0;

   setupRoutingEvents();
   setupModalEvents();
   // setupMenuEvents();
   // setupAgendaEvents();
   // setupGlobalEvents();
   // setupScrollEvents();
   setupCountdownEvents();
   // setupGAEvents();
   setupSliders();

   // if (window._moduleJs){
   //    moduleRouter(_moduleJs);
   // }

   window._views = {

      /**
		 * SPEED constant used in various view transition effects
		 * @type {Integer} Transition time in milliseconds
		 */
      SPEED: 200,

      /**
		 * Checks for fixed position menus and returns the distance
		 * to the readable portion of the document.
		 * Useful for searching/scrolling operations.
		 * @return {integer} Distance from top of browser to readable portion.
		 */
      contentOffset,

      /**
		 * Scrolls to a pixel location on page
		 * @param  {integer} location  pixel destination in document
		 * @param  {integer} scrollTime  ms to reach destination
		 * @return {undefined}
		 */
      scrollTo,

      /**
		 * Deprecated function for initializing maps. Use a map image instead.
		 */
      initMap: function() {
         console.warn("VIEWS WARNING: initMap is deprecated. Use a map image instead.");
      },
   };

   // console debug messages
   // if (!PRODUCTION){
   //    if (typeof _consoleDebugs !== "undefined" && _consoleDebugs.length){
   //       for (let c of _consoleDebugs){
   //          console.log(c.label, c.var);
   //       }
   //    }
   // }

}

